import React from "react";
import { Modal, Form, Input } from "antd";

const LinkModal = ({ visible, toggle, selectedPostID }) => {
  const link = `https://app.paradigma.education/feed/post/view?id=${selectedPostID}`;
  return (
    <Modal
      title="Sharable Link"
      open={visible}
      onCancel={toggle}
      onOk={toggle}
      destroyOnHidden
    >
      <Form.Item>
        <Input value={link} />
      </Form.Item>
    </Modal>
  );
};

export default LinkModal;
